import { render, staticRenderFns } from "./CabinConfig.vue?vue&type=template&id=5c4d062f"
import script from "./CabinConfig.vue?vue&type=script&lang=js"
export * from "./CabinConfig.vue?vue&type=script&lang=js"
import style0 from "./CabinConfig.vue?vue&type=style&index=0&id=5c4d062f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports